import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import Editunitmodal from "./editunitmodal";

const Unitlist = () => {
    const { initState, recaller, setrecaller, clear, initDispatch } =
        useContext(GlobalContext);
    
    const [unit_id, setunit_id] = useState();
    const [unit_name, setunit_name] = useState();
    const [show, setshow] = useState(false);
    return (
        <div>
            <Editunitmodal unit_id={unit_id} unit_name={unit_name} setunit_name={setunit_name} show={show} setshow={setshow} />
            
            {/* Unit List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی یەکە</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">ناوی یەکە</th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">گۆڕانکاری</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {initState.unit.map((lis) => (
                            <tr key={lis.unit_id} className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.unit_name}
                                </td>
                                <td className="px-6 py-4 text-right">
                                    <button
                                        className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-colors cursor-pointer"
                                        onClick={() => {
                                            setunit_id(lis.unit_id);
                                            setunit_name(lis.unit_name);
                                            setshow(true);
                                        }}
                                    >
                                        گۆڕانکاری
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Unitlist